import { render, staticRenderFns } from "./setPwdDc.vue?vue&type=template&id=120e102f&scoped=true"
import script from "./setPwdDc.vue?vue&type=script&lang=js"
export * from "./setPwdDc.vue?vue&type=script&lang=js"
import style0 from "./setPwdDc.vue?vue&type=style&index=0&id=120e102f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120e102f",
  null
  
)

export default component.exports